/**
 * sortLeadsForColumn — Pure Function (BOARD-05).
 *
 * Filtert Leads auf den uebergebenen Status und sortiert nach Spalten-Regel:
 * - oldest_first → entered_status_at ASC (aelteste oben)
 * - newest_first → updated_at DESC (neueste oben)
 *
 * Pure: kein Mutieren der Input-Liste, kein Datum-Mocking noetig.
 */

import type { Lead, LeadStatus } from '../types';
import { COLUMNS } from './columns';

export function sortLeadsForColumn(leads: Lead[], status: LeadStatus): Lead[] {
  const col = COLUMNS.find((c) => c.status === status);
  const sortMode = col?.sort ?? 'newest_first';

  const inColumn = leads.filter((l) => l.status === status);

  if (sortMode === 'oldest_first') {
    return [...inColumn].sort(
      (a, b) =>
        new Date(a.enteredStatusAt).getTime() - new Date(b.enteredStatusAt).getTime(),
    );
  }
  return [...inColumn].sort(
    (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime(),
  );
}
